export const BASE_URL = 'https://taste-on-way.onrender.com'

// export const BASE_URL = 'http://localhost:8000'